import { t } from "@/lib/strings";
import { BRAND } from "@/lib/tokens";
import type { PrintDoc } from "@/lib/memoPrint";

/**
 * The masthead of a printed Protokoll: the LogicLine wordmark, the memo title,
 * its date/week/time line, and the participant roll. A draft carries an ENTWURF
 * pill so a printout that is not yet finalized can never be mistaken for final
 * minutes. Pure and static — no controls, no fetching. Fixed brand hexes (not
 * theme tokens): print is always light.
 */
export function PrintHeader({ doc }: { doc: PrintDoc }) {
  const meta = `${doc.dateLabel} · ${doc.weekLabel}${doc.timeLabel ? " · " + doc.timeLabel : ""}`;
  const participants = `${t.printParticipants}: ${doc.participantNames.join(", ")} (${doc.participantCount})`;

  return (
    <header className="memo-print" style={{ marginBottom: 20 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 14,
        }}
      >
        <img src="/logicline-logo.png" alt="LogicLine" style={{ height: 22 }} />
        {doc.isDraft ? (
          <span
            className="memo-print-draft"
            style={{
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              color: BRAND.orange,
              border: `1px solid ${BRAND.orange}`,
              // radius + padding are owned by `.memo-print-draft` (pill shape); no
              // inline overrides here or the class loses and it renders as a rectangle.
            }}
          >
            {t.printDraftLabel}
          </span>
        ) : null}
      </div>

      <h1 style={{ fontSize: 22, fontWeight: 700, color: BRAND.blueDark, margin: 0 }}>
        {doc.title}
      </h1>

      <div style={{ fontSize: 12.5, color: BRAND.blueGreyDk, marginTop: 6 }}>{meta}</div>
      <div style={{ fontSize: 12.5, color: BRAND.blueGreyDk, marginTop: 2 }}>{participants}</div>
    </header>
  );
}
